import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { goBackToEvents } from 'app/events/helpers/back-to-events';
import { invalidateApolloCacheFor } from 'core/apollo-cache-invalidator';
import { NavigationService } from 'core/navigation.service';
import { CalendarEventDetailsFragment, DeleteCalendarEventGQL } from 'generated/graphql';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-delete-event-dialog',
  templateUrl: `./delete-event.dialog.html`,
})
export class DeleteEventDialog  {

  calendarEvent: CalendarEventDetailsFragment | null = null;
  isSubmitting = false;

  static open(dialog: MatDialog, config: MatDialogConfig<any>) {
    return dialog.open(DeleteEventDialog, config);
  }

  constructor(
    private _deleteCalendarEventGQL: DeleteCalendarEventGQL,
    public dialogRef: MatDialogRef<DeleteEventDialog>,
    private _navigationService: NavigationService,
    private _route: ActivatedRoute,
    private _router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.eventDetails) {
      this.calendarEvent = data.eventDetails;
    }
  }

  close() {
    this.dialogRef.close();
  }


  deleteEventClicked() {
    this.isSubmitting = true;
    this._deleteCalendarEventGQL
      .mutate({ input: { id: this.calendarEvent.id } },
        {
          update: (cache) => {
            invalidateApolloCacheFor(cache, c => c.fieldName?.includes('searchCalendarEvents'));
          }
        })
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(({ data }) => {
        this.close();
        // Redirect to event page
        goBackToEvents(this._route.snapshot.queryParams['campaignId'], this._navigationService, this._router);
      });
  }
}
